import { useEffect } from "react";
import { getCompanyTitle } from "@/Utils/environment";

export function usePageTitle(title: string) {

  useEffect(() => {
    const companyTitle = getCompanyTitle();
    document.title =  `${companyTitle} | ${title}`;
  }, [title]);
}